var $ = require('jquery');

module.exports.run = function (options) {
    var record = options.record;
    var deferred = $.Deferred();
    var promise = deferred.promise();

    deferred.resolve(record);
    record.trigger('cancel', record);
    return promise;
};


// WEBPACK FOOTER //
// ./js/Modules/Record/Action/RecordActionCancel.js